import { HelpMessage } from 'utils/constants'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'
import NameFormItem from 'components/CIMSFormItem/common/NameFormItem'
import UserAndRolesFormItem from 'components/CIMSFormItem/common/UserAndRolesFormItem'

const CreateEditModalBody: React.FC = () => {
  return (
    <>
      <NameFormItem
        help={HelpMessage.FieldDesignChanges.Concurrences.Groups.Name}
      />
      <DescriptionFormItem entityName="Concurrence Group" />
      <UserAndRolesFormItem
        label="Concurrers"
        action="concur on, or reject, the Concurrence Level of a Field Design Change"
      />
    </>
  )
}

export default CreateEditModalBody
